import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import DiarioService from '../../../../../services/diario-auth';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [edicao, setEdicao] = useState("");
    const [ano, setAno] = useState("");
    const [mes, setMes] = useState("");



    const busca = async (query) => {
        if (query == "") {
            props.setAindaTem(true)
            await props.fetchDiariosIn()
            setAno("")
            setEdicao("")
            setMes("")
        } else {
            var response = await DiarioService.buscar(query)
            if (response.data.length >= 1) {
                props.setDiarios(response.data)
                props.setAindaTem(false)
                props.setVazio(false)
                setAno("")
                setEdicao("")
                setMes("")
            } else {
                props.setVazio(true)
                setAno("")
                setEdicao("")
                setMes("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (mes) prepQuery = prepQuery + `mes=${mes}`;
        if (edicao) prepQuery = prepQuery + `&edicao=${edicao}`;
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Edição">
                                <FloatingLabel
                                    label="Edição"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="edicao"
                                        value={edicao}
                                        onChange={e => setEdicao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Mês">
                                <FloatingLabel
                                    label="Mês"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="mes"
                                        value={mes}
                                        onChange={e => setMes(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/diario'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
